// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardTcsWrapperModelsMedicationModel {
    static getAttributeTypeMap() {
        return CardTcsWrapperModelsMedicationModel.attributeTypeMap;
    }
}
CardTcsWrapperModelsMedicationModel.discriminator = undefined;
CardTcsWrapperModelsMedicationModel.additionalProperties = false;
CardTcsWrapperModelsMedicationModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
];
//# sourceMappingURL=cardTcsWrapperModelsMedicationModel.js.map